import { createSlice } from "@reduxjs/toolkit";
import {
  getDelegatesList,
  addDelegate,
  deleteDelegate,
  getDelegateById,
  assignPersons,
  updateDelegate,
  getDelegatesSummary,
} from "./delegatesThunk";

const initialState = {
  delegatesList: {
    data: [],
    loading: false,
    error: null,
  },
  newDelegate: {
    data: null,
    loading: false,
    error: null,
  },
  deletedDelegate: {
    data: null,
    loading: false,
    error: null,
  },
  oneDelegateById: {
    data: null,
    loading: false,
    error: null,
  },
  assigned: {
    data: null,
    loading: false,
    error: null,
  },
  updatedDelegate: {
    data: null,
    loading: false,
    error: null,
  },
  delegatesSummary: {
    data: [],
    loading: false,
    error: null,
  },
};

const delegatesSlice = createSlice({
  name: "delegates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // all delegates
      .addCase(getDelegatesList.pending, (state) => {
        state.delegatesList.loading = true;
        state.delegatesList.error = null;
      })
      .addCase(getDelegatesList.fulfilled, (state, action) => {
        state.delegatesList.loading = false;
        state.delegatesList.data = action.payload;
      })
      .addCase(getDelegatesList.rejected, (state, action) => {
        state.delegatesList.loading = false;
        state.delegatesList.error = action.error.message;
      })
      
      // add delegate
      .addCase(addDelegate.pending, (state) => {
        state.newDelegate.loading = true;
        state.newDelegate.error = null;
      })
      .addCase(addDelegate.fulfilled, (state, action) => {
        state.newDelegate.loading = false;
        state.newDelegate.data = action.payload;
      })
      .addCase(addDelegate.rejected, (state, action) => {
        state.newDelegate.loading = false;
        state.newDelegate.error = action.error.message;
      })
      
      // delete delegate
      .addCase(deleteDelegate.pending, (state) => {
        state.deletedDelegate.loading = true;
        state.deletedDelegate.error = null;
      })
      .addCase(deleteDelegate.fulfilled, (state, action) => {
        state.deletedDelegate.loading = false;
        state.deletedDelegate.data = action.payload;
      })
      .addCase(deleteDelegate.rejected, (state, action) => {
        state.deletedDelegate.loading = false;
        state.deletedDelegate.error = action.error.message;
      })
      
      // get delegate by id
      .addCase(getDelegateById.pending, (state) => {
        state.oneDelegateById.loading = true;
        state.oneDelegateById.error = null;
      })
      .addCase(getDelegateById.fulfilled, (state, action) => {
        state.oneDelegateById.loading = false;
        state.oneDelegateById.data = action.payload;
      })
      .addCase(getDelegateById.rejected, (state, action) => {
        state.oneDelegateById.loading = false;
        state.oneDelegateById.error = action.error.message;
      })
      
      // assign persons
      .addCase(assignPersons.pending, (state) => {
        state.assigned.loading = true;
        state.assigned.error = null;
      })
      .addCase(assignPersons.fulfilled, (state, action) => {
        state.assigned.loading = false;
        state.assigned.data = action.payload;
      })
      .addCase(assignPersons.rejected, (state, action) => {
        state.assigned.loading = false;
        state.assigned.error = action.error.message;
      })
      // update delegate
      .addCase(updateDelegate.pending, (state) => {
        state.updatedDelegate.loading = true;
        state.updatedDelegate.error = null;
      })
      .addCase(updateDelegate.fulfilled, (state, action) => {
        state.updatedDelegate.loading = false;
        state.updatedDelegate.data = action.payload;
      })
      .addCase(updateDelegate.rejected, (state, action) => {
        state.updatedDelegate.loading = false;
        state.updatedDelegate.error = action.error.message;
      })
      // Gérer les cas pour le résumé
      .addCase(getDelegatesSummary.pending, (state) => {
        state.delegatesSummary.loading = true;
        state.delegatesSummary.error = null;
      })
      .addCase(getDelegatesSummary.fulfilled, (state, action) => {
        state.delegatesSummary.loading = false;
        state.delegatesSummary.data = action.payload;
      })
      .addCase(getDelegatesSummary.rejected, (state, action) => {
        state.delegatesSummary.loading = false;
        state.delegatesSummary.error = action.payload;
      });

  },
});

export default delegatesSlice.reducer;